export const AgentDomain = {
  CONCIERGE: "concierge",
};

export const ApiResponseStatus = {
  DONE: "done",
  GUARDRAIL: "guardrail",
  STREAM: "stream",
  METADATA: "metadata",
};

export const MessaggeType = {
  SENT: "sent",
  RECEIVED: "received",
};

export const MarketingStatus = {
  ACTIVE: "ACTIVE",
  MANUAL: "MANUAL",
  DRAFT: "DRAFT",
  CANCELLED: "CANCELLED",
  MANUAL: "MANUAL",
  RUNNING: "RUNNING",
};

export const AgentTypes = {
  INTERNAL: "Internal",
  CONSUMER: "Consumer",
};

export const AgentStatus = {
  ACTIVE: "Published",
  DRAFT: "Draft",
};

export const AgentModifiedPeriods = {
  LAST_7_DAYS: "Last 7 days",
  LAST_30_DAYS: "Last 30 days",
  LAST_90_DAYS: "Last 90 days",
  THIS_YEAR: "This year",
};

export const getAgentTypesArray = () => Object.values(AgentTypes);
export const getAgentStatusArray = () => Object.values(AgentStatus);
export const getAgentModifiedPeriodsArray = () => Object.values(AgentModifiedPeriods);

export const PermissionCodes = {
  USER_PERSONA_TAB: "USER_PERSONA_TAB",
  USER_PERSONA_FIELD: "USER_PERSONA_FIELD",
  USER_PERSONA_BUILDER: "USER_PERSONA_BUILDER",
  DATA_MODULE: "DATA_MODULE",
  DATA_CONTACTS: "DATA_CONTACTS",
  CONTACTS_CREATE: "CONTACTS_CREATE",
  UCP_ACCESS: "UCP_ACCESS",
  UCP_CONTACT_INFO: "UCP_CONTACT_INFO",
  UCP_GARAGE: "UCP_GARAGE",
  UCP_TEAM: "UCP_TEAM",
  UCP_APPOINTMENTS: "UCP_APPOINTMENTS",
  UCP_OPPORTUNITIES: "UCP_OPPORTUNITIES",
  UCP_NOTIFICATIONS: "UCP_NOTIFICATIONS",
  UCP_REPAIR_ORDERS: "UCP_REPAIR_ORDERS",
  UCP_NOTES: "UCP_NOTES",
  DATA_VEHICLES: "DATA_VEHICLES",
  DATA_REPAIR_ORDERS: "DATA_REPAIR_ORDERS",
  DATA_APPOINTMENTS: "DATA_APPOINTMENTS",
  DATA_INVENTORY: "DATA_INVENTORY",
  AGENTS_VIEW: "AGENTS_VIEW",
  AGENTS_CREATE: "AGENTS_CREATE",
  AGENTS_DUPLICATE: "AGENTS_DUPLICATE",
  AGENTS_UPDATE: "AGENTS_UPDATE",
  PLAYGROUND_VIEW: "PLAYGROUND_VIEW",
  PLAYGROUND_SHARE: "PLAYGROUND_SHARE",
  PLAYGROUND_DUPLICATE: "PLAYGROUND_DUPLICATE",
  PLAYGROUND_BASIC: "PLAYGROUND_BASIC",
  BASIC_PICTURE: "BASIC_PICTURE",
  BASIC_NAME: "BASIC_NAME",
  BASIC_CATEGORY: "BASIC_CATEGORY",
  BASIC_DESCRIPTION: "BASIC_DESCRIPTION",
  BASIC_PROMPT: "BASIC_PROMPT",
  BASIC_INSTRUCTIONS: "BASIC_INSTRUCTIONS",
  BASIC_STARTERS: "BASIC_STARTERS",
  BASIC_KNOWLEDGE: "BASIC_KNOWLEDGE",
  BASIC_ACTIONS: "BASIC_ACTIONS",
  BASIC_CONCIERGE: "BASIC_CONCIERGE",
  BASIC_TYPE: "BASIC_TYPE",
  PLAYGROUND_ADVANCED: "PLAYGROUND_ADVANCED",
  ADVANCED_LLM: "ADVANCED_LLM",
  ADVANCED_SIGNATURE: "ADVANCED_SIGNATURE",
  CONVERSATIONS_VIEW: "CONVERSATIONS_VIEW",
  MARKETING: "MARKETING",
  DUPLICATE_CAMPAIGNS: "DUPLICATE_CAMPAIGNS",
  ARCHIVE_CAMPAIGNS: "ARCHIVE_CAMPAIGNS",
  CREATE_NEW: "CREATE_NEW",
  SEGMENTS: "SEGMENTS",
  ADD_FILTER_GROUP: "ADD_FILTER_GROUP",
  IMPORT_CSV: "IMPORT_CSV",
  MESSAGE: "MESSAGE",
  GENERAL_SETUP: "GENERAL_SETUP",
  VARIABLES_SETUP: "VARIABLES_SETUP",
  OVERVIEW: "OVERVIEW",
  MARKETING_INFO: "MARKETING_INFO",
  RETRIES: "RETRIES",
  AGENT_SELECTION: "AGENT_SELECTION",
  ADVANCED_SETTINGS: "ADVANCED_SETTINGS",
  HITL: "HITL",
  DEFAULT_ASSIGNMENT: "DEFAULT_ASSIGNMENT",
  SPECIFIC_USER: "SPECIFIC_USER",
  ROUND_ROBIN: "ROUND_ROBIN",
  CONVERSATIONS_VIEWER: "CONVERSATIONS_VIEWER",
  APPROVE_MESSAGES: "APPROVE_MESSAGES",
  EDIT_MESSAGES: "EDIT_MESSAGES",
};

export const PermissionLevels = {
  VIEW: "v",
  CREATE: "c",
  UPDATE: "u",
  DELETE: "d",
};

export const DefaultValues = {
  UNKNOWN: "Unknown",
};

export const NoteCategories = {
  GENERAL: "General",
  FOLLOW_UP: "Follow-Up",
  OPPORTUNITY: "Opportunity",
  URGENT: "Urgent",
  MANAGER_REVIEW: "Manager Review",
};

export const PHOTO_UPLOAD_STAGES = {
  IDLE: 0,
  PUTTING_FILE_NAME: 1,
  UPLOADING_FILE_TO_S3: 2,
  GETTING_IMAGE_FROM_PHOTO_URL: 3,
  FINISHED_PHOTO_UPLOAD: 4,
};

export const STAGE_PERCENTAGES = {
  [PHOTO_UPLOAD_STAGES.IDLE]: 0,
  [PHOTO_UPLOAD_STAGES.PUTTING_FILE_NAME]: 33,
  [PHOTO_UPLOAD_STAGES.UPLOADING_FILE_TO_S3]: 66,
  [PHOTO_UPLOAD_STAGES.GETTING_IMAGE_FROM_PHOTO_URL]: 90,
  [PHOTO_UPLOAD_STAGES.FINISHED_PHOTO_UPLOAD]: 100,
};

export const NotificationTab = {
  UnreadTab: 0,
  ReadTab: 1,
};

export const ItemStatus = {
  unread: "UNREAD",
  read: "READ",
};

export const AGENT_ROLES = ["assistant", "agent", "annaims"];

export const NOTE_CATEGORIES_LIST = Object.values(NoteCategories);

export const OriginVariables = {
  FIXED: 'FIXED',
  EVENT: 'EVENT'
}

export const DefaultFieldVariables = {
  TO: 'To',
  AGENT_NAME: 'agent_name',
  AGENT_POSITION: 'agent_position',
  COMPANY_NAME: 'company_name',
  CUSTOMER_NAME: 'customer_name'
};

export const DefaultVariables = [
  { isDefault: true, name: "To", origin: OriginVariables.EVENT, variable: DefaultFieldVariables.TO, field: 'email', source: 'contacts', value:"email" },
  { isDefault: true, name: "Agent Name", origin: OriginVariables.FIXED, variable: DefaultFieldVariables.AGENT_NAME },
  { isDefault: true, name: "Agent Position", origin: OriginVariables.FIXED, variable: DefaultFieldVariables.AGENT_POSITION },
  { isDefault: true, name: "Company Name", origin: OriginVariables.FIXED, variable: DefaultFieldVariables.COMPANY_NAME },
  { isDefault: true, name: "Customer Name", origin: OriginVariables.EVENT, variable: DefaultFieldVariables.CUSTOMER_NAME, field: 'first_name', source: 'contacts' },
];

export const FIELD_VALIDATIONS = {
  first_name: {},
  last_name: {},
  email: {
    pattern: /^\s*(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[^"])*")@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\s*$/,
    string_pattern: "[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?",
    error: "Please enter a valid email address. The email should follow a standard format (e.g., user@domain.com)",
    required: true
  },
  company_name: {
    pattern: /^\s*[\w\s\-&.,'"()!@#$%]+\s*$/,
    error: "Company Name contains invalid characters",
    required: false
  },
  address: {
    pattern: /^\s*[\w\s\-,.#&/()'"]+\s*$/,
    error: "Address contains invalid characters",
    required: false
  },
  city: {
    pattern: /^\s*[A-Za-z\s]+\s*$/,
    error: "City should only contain letters",
    required: false
  },
  state: {
    pattern: /^\s*[A-Za-z\s]+\s*$/,
    error: "State should only contain letters",
    required: false
  },
  postal_code: {
    pattern: /^\s*\d{5}(-\d{4})?\s*$/,
    string_pattern: "\\d{5}(-\\d{4})?",
    error: "Invalid postal code format",
    required: false
  },
  phone: {
    pattern: /^\s*\+?(?:[\d()\s-]*\d[\d()\s-]*){10,}\s*$/,
    error: "Phone number must have only numbers and at least 10 digits.",
    required: false
  }
};

export const VALIDATION_MESSAGES = {
  NO_MAPPINGS: "No field mappings defined. Please map at least one field.",
  NO_DATA: "No data to validate. Please upload a file with data.",
  EMAIL_REQUIRED: "Email is a required.",
  FIRST_NAME_AND_EMAIL_REQUIRED: "Name and Email are required. Please update your file and try again",
  UPLOAD_ERROR: (message) => `Error uploading file: ${message}`,
  VALIDATION_MODAL: {
    TITLE: "Validation Errors",
    SUBTITLE: "There are issues in your file:",
  }
};

export const RowStatus = {
  RESOLVED: "completed",
  UNRESOLVED: "pending",
  UNRESOLVED_RAW: "unresolved",
  RESOLVED_RAW: "resolved"
};

export const MarketingErrorMessages = {
  MESSAGE_TAB: {
    title: "Missing Segment",
    message: "Complete your segment selection or CSV upload before creating your message. This ensures proper email destinations and variables."
  },
  SEGMENT_CONTACT_DATA:{
    message: "No uploaded data found. Please re-upload your CSV file."
  },
  PREVENT_PUBLISH_WITHOUT_AGENT: {
    title: "Error",
    message: "An agent is required to publish this campaign. Please assign an agent in the Overview tab."
  },
  PREVENT_DRAFT_WITHOUT_AGENT: {
    title: "Warning",
    message: "No agent is assigned. Do you want to save this campaign as a draft?"
  },
  REDIRECT_MESSAGE_DRAFT_SUCCESS: {
    title: "Your campaign has been saved.",
    message: "You can resume editing anytime."
  },
  REDIRECT_MESSAGE_DRAFT_ERROR: {
    title: "We couldn't save your campaign.",
    message: "You'll be redirected shortly."
  },
  FILTER_ERROR: {
    message: "The filters could not be loaded."
  }
}

export const CustomerTableMessages = {
  NO_RECORDS: "No records to display",
  ERROR_UPDATE: "Error updating customer",
  ERROR_EDIT: "Could not get customer for editing",
  SUCCESS_UPDATE: "Customer updated successfully",
  ERROR_LOADING: "Error loading customers"
};

export const TableAlignment = {
  CENTER: "center"
};

export const CustomerTableColumns = {
  NAME: "name",
  USER_COUNT: "user_count",
  STREET: "street",
  CITY: "city",
  STATE: "state",
  ZIP_CODE: "zip_code",
  DOMAINS: "domains",
  DEFAULT_EMAIL: "default_email"
};

export const CustomerTableHeaders = {
  [CustomerTableColumns.NAME]: "Company Name",
  [CustomerTableColumns.USER_COUNT]: "Number of Users",
  [CustomerTableColumns.STREET]: "Address",
  [CustomerTableColumns.CITY]: "City",
  [CustomerTableColumns.STATE]: "State or Province",
  [CustomerTableColumns.ZIP_CODE]: "Postal Code",
  [CustomerTableColumns.DOMAINS]: "Domains",
  [CustomerTableColumns.DEFAULT_EMAIL]: "Default Email"
};

export const ModalTitles = {
  SUCCESS: "Success!"
};

export const CurrentFilterEnum = {
  MAKE: 'make',
  MODEL: 'model',
  YEAR: 'year',
  TYPE: 'type',
  ANGLE: 'angle',
  BACKGROUND: 'background',
  SIZE: 'size'
}

export const MarketingTab = {
  Segments: 0,
  Message: 1,
  Overview: 2,
  AdvancedSettings: 3,
  AuditLogs: 4,
};

export const PlaygroundTabs = {
  CREATE: {
    id: 0,
    label: 'Create'
  },
  BASIC: {
    id: 1,
    label: 'Basic'
  },
  ADVANCED: {
    id: 2,
    label: 'Advanced'
  }
};

export const RuleEngineEnums = {
  DestinyTypes: {
    VARIABLE: "VARIABLE",
    CONSTANT: "CONSTANT"
  },

  FieldTypes: {
    DATE: "DATE",
    TIME: "TIME"
  },

  Operators: {
    IN: "IN",
    NOT_IN: "NOT_IN",
    BETWEEN: "BETWEEN"
  }
};

export const OperatorsEnum = {
  EQ: 'Equal',
  NEQ: 'Not Equal',
  CONTAINS: 'Contains',
  STARTS_WITH: 'Starts With',
  ENDS_WITH: 'Ends With',
  IN: 'In',
  NOT_IN: 'Not In',
  BETWEEN: 'Between',
  LT: 'Less Than',
  GT: 'Greater Than',
  LTE: 'Less Than or Equal',
  GTE: 'Greater Than or Equal',
}

export const DefaultDestinyList = [
  { name: "Variable", value: "VARIABLE" },
  { name: "Constant", value: "CONSTANT" }
];

export const MemberRoleMapping = {
  SALES_REP: "Sales Representative",
  SERVICE_REP: "Service Representative",
  BDC_AGENT: "BDC Agent Name",
  SALES_MNG: "Sales Manager"
}

export const UCPAgentVersion = {
  BETA: "beta",
  DEFAULT: "default"
};

export const AssistantFnTypes = {
  UCP_LANGCHAIN: "ucp_langchain"
}

export const AdvancedSettingsAssignmentTypes = {
  CONTACT: "contact",
  DEFAULT: "default",
  SINGLE: "single",
  CUSTOM: "custom"
}

export const AgentDeletionMessages = {
  SUCCESS: "Agent deleted successfully.",
  ACTIVE_CAMPAIGN: "This agent is currently assigned to an active campaign and can't be deleted in this moment.",
  ONGOING_ACTIVITIES: "This agent cannot be deleted as they are associated with ongoing activities.",
  DEFAULT: "Agent deletion failed. Please try again.",
  NOT_FOUND: "Not Found."
};

export const ConfirmationModalMessages = {
  DISCARD_CHANGES: {
    title: "Warning",
    message:
      "Are you sure you want to discard the changes in this agent? Any changes made to your agent will be lost. Are you sure you want to proceed?"
  },
  DUPLICATE: {
    title: "Duplicate",
    message:
      "Caution: You are about to duplicate the agent. Are you sure you want to continue?"
  },
  DELETE: {
    title: "Are you sure you want to delete?",
    message:
      "Deleting this agent is permanent and cannot be undone. Do you want to proceed?"
  }
};

export const AgentsWidgetTabs = {
  CHAT: 0,
  HISTORY: 1
};

export const AgentValidationMessages = {
  CATEGORY_REQUIRED: {
    title: "Validation Error",
    message: "You must select a category to continue"
  }
};

export const SUCCESS_ALERT_DURATION = 3000;

export const VALIDATION_PATTERNS = {
  SCHEDULING_URL: {
    pattern: /^(https:\/\/|www\.)[^\s]+(\.[a-zA-Z]{2,})(\/[^\s]*)?$/i
  }
}

export const ActionsLibraryMessages = {
  SETUP_SUCCESS: {
    title: "Configuration updated successfully",
    message: "Your settings have been successfully updated. All changes are now in effect."
  },
  INCOMPLETE_SETUP: {
    title: "Incomplete Action Setup",
    message: "You've added an action, but it hasn't been configured yet. Complete the setup to ensure it functions properly."
  },
  DISCARD_CHANGES: {
    title: "Incomplete Action Setup",
    message: "This action cannot be added to this agent until it is fully configured and saved."
  },
  INVALID_URL: {
    title: "Invalid link",
    message:
      "The scheduling link you entered is not valid. Please check the URL and try again."
  }, 
  EMPTY_URL: {
    title: "Empty field detected",
    message:
      "This field cannot be left empty. Please enter the required information and try again."
  },
  EMPTY_LINK_NAME: {
    title: "Empty field detected",
    message:
      "This field cannot be left empty. Please enter the required information and try again."
  }, 
  MISSING_BOTH_FIELDS: {
    title: "Missing Required Fields",
    message: "The following fields must be filled out before you can proceed:",
    fields: ["Scheduling Link", "Link Name"]
  }
};

export const ErrorTypeEnum = {
  EMPTY_URL: "EMPTY_URL",
  INVALID_URL: "INVALID_URL",
  EMPTY_LINK_NAME: "EMPTY_LINK_NAME",
  MISSING_BOTH_FIELDS: "MISSING_BOTH_FIELDS"
};

export const FilterTypes = {
  USER: 'user',
  GROUP: 'group',
  ROLE: 'role'
};

export const HistoryGroups = {
    TODAY: 'Today',
    YESTERDAY: 'Yesterday',
    LAST_WEEK: '7 days ago',
    LAST_MONTH: 'One month ago',
    MORE: 'More'
};

export const UCPHistoryGroups = {
    TODAY: 'Today',
    YESTERDAY: 'Yesterday',
    LAST_WEEK: 'Last 7 days',
    LAST_MONTH: 'Last 30 days'
};

export const PlaygroundTabsEnum = {
  CREATE: 0,
  BASIC: 1,
  ADVANCED: 2
};


export const assistantListFileRoute = "knowledge_base_openai";

export const validFileExtensions = ["txt", "pdf", "json", "docx", "csv"];

export const extensions = {
    "application/vnd.ms-excel": [".xls"],
    "text/csv": [".csv"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
    ],
    "application/msword": [".docx"],
    "text/plain": [".txt"],
    "application/pdf": [".pdf"],
    "application/json": [".json"],
};

export const initialTones = {
    friendly: false,
    enthusiastic: false,
    direct: false,
    professional: false,
    cordial: false,
    helpful: false
};

export const initialChannels = {
    voice: false,
    sms: false,
    webchat: false,
    email: false,
    'qna-webchat': false,
};

export const initialActions = {
    send_sms: false,
    send_email: false,
    appointments_schedule: false,
};

export const triggerRole = [
    {name:'User', value: 'user'},
    {name:'Admin',value: 'admin'},
    {name:'Customer',value: 'customer'},
    {name:'Sales - Rep',value: 'salesRep'},
    {name:'Service - Rep',value: 'serviceRep'},
    {name:'Sales Manager', value: 'salesManager'}
];

export const activityOptions = [
    {name:'Request a meeting', value: 'requestMeeting'},
    {name:'Assing to a user',value: 'assingUser'},
    {name:'Request a test drive',value: 'requestTestDrive'},
    {name:'Request a  quote',value: 'requestQuote'},
    {name:'Ask to talk to a human',value: 'askTalkHuman'}
];

export const thatOption = [
    {name:'Send internal Email', value: 'internEmail'},
    {name:'Send internal SMS', value: 'internalSms'},
    {name:'Call', value: 'call'},
    {name:'Reply via Email', value: 'replyEmail'},
    {name:'Reply via SMS', value: 'replySms'}
];

export const agentType = [
    {name: 'Private', value: 'private'},
    {name: 'Public/Consumer', value: 'public'},
    {name: 'Internal', value: 'internal'}
];

export const answerType = [
    {name: 'Summarized', value: 'summarized'},
    {name: 'Extensive', value: 'extensive'}
];

export const persona = [
    {name: 'Ethan (Sales Manager)', value: 'ethan'},
    {name: 'Isabella (Services Manager)', value: 'isabella'},
    {name: 'Benjamin (Operations Specialist)', value: 'benjamin'},
    {name: 'Ava (Operations Specialist)', value: 'ava'},
];

export const PromptConfigViewsEnum = {
  CREATE: 0,
  CONFIG: 1,
};

/**
 * WebSocket Scope Enum
 * 
 * Define los scopes válidos para mensajes WebSocket.
 * Solo estos scopes están permitidos en la aplicación.
 */
export const WebSocketScope = {
  NOTIFICATION: "NOTIFICATION",
  CONVERSATION: "CONVERSATION",
};